import { z } from 'zod';

import { zodSuccessResponseSchema } from '../validations';

export const zodApproveDlnItemPayloadSchema = z.object({
  acceptedQuantityFactor: z.number().min(0).max(1).nullable(),
});

export const zodApproveDlnItemEndpointSchema = z.tuple([
  z.literal('delivery_note'),
  z.uuid(),
  z.literal('item'),
  z.number().int(),
  z.literal('approve'),
]);

export const zodApproveDlnItemResponseSchema = zodSuccessResponseSchema;
